module.exports = __webpack_public_path__ + "img/niu9.f6156ace.jpg";